import { styled, Theme } from '@mui/material/styles';
import { Link } from '@mui/material';

export const AuthAlternative = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const Error = styled('div')(({ theme }: { theme: Theme }) => ({
  color: theme.palette.error.main,
  display: 'flex',
  justifyContent: 'center',
}));

export const LinkStyled = styled(Link)(({ theme }: { theme: Theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  marginLeft: theme.spacing(1),
}));
